const getNotifications = (state) => {
  return state.notifications
}

const getNotificationsInProgress = (state) => {
  return state.fetchNotificationsInProcess
}

const setNotificationsInProgress = (state) => {
  return state.setNotificationsInProcess
}

export default {
  getNotifications,
  getNotificationsInProgress,
  setNotificationsInProgress
}



// WEBPACK FOOTER //
// ./src/store/modules/user/notifications/getters.js